export default __webpack_public_path__ + "media/Dairy.508b4f61.png";